import React from 'react';
import translate from '../../../_utils/tools/translate';
import Store from '../../../_utils/tools/store';

export default function OptionsWrapper({
  finishWrapper,
  children,
  className,
  disabledOptions,
  blockingOption,
}) {
  const title =
    (finishWrapper && 'Paper Finish') || `${translate('Shipping')} Method`;
  const disabledOptionLabels = disabledOptions
    .map(o => o.label)
    .filter(Boolean);
  const disabledOptionMessage =
    disabledOptionLabels.length > 0 && blockingOption
      ? `${disabledOptionLabels.join(', ')} not available for ${
          blockingOption.title
        }`
      : null;
  const displayDisabledOption = Store.isWalmart() && disabledOptionMessage;
  const titleOption = (finishWrapper && 'finish') || 'delivery';

  return (
    <>
      <div className={`clearfix my-1 options-wrapper__${titleOption}-title`}>
        <h6 className="float-left mb-0 ml-1">{title}</h6>
        {displayDisabledOption && (
          <span className="small float-right">{disabledOptionMessage}</span>
        )}
      </div>
      <div className={className}>{children}</div>
    </>
  );
}

OptionsWrapper.defaultProps = {
  disabledOptions: [],
};
